export default __webpack_public_path__ + "static/media/directions.5def6754.svg";